import axios from "axios";
import { getIdToken, getIdTokenResult } from "firebase/auth";
import { env } from "../env";
import { auth } from "../configurations";
import { store } from "../redux/store";
import { setSession } from "../redux/slices/session";
import { clearUser } from "../redux/slices/user";
import { setIsLoading } from "../redux/slices/appControl";

let pendingRequests = 0;

const showLoading = () => {
  pendingRequests += 1;
  store.dispatch(setIsLoading(true));
};

const hideLoading = () => {
  pendingRequests = Math.max(0, pendingRequests - 1);
  if (pendingRequests === 0) {
    store.dispatch(setIsLoading(false));
  }
};

const getAuthToken = async (tokenFromConfig) => {
  if (tokenFromConfig) return tokenFromConfig;

  const session = store.getState().session;
  if (!session?.token) return "";

  if (Math.floor(Date.now() / 1000) < session.expiration) return session.token;

  const user = auth.currentUser;
  if (!user) {
    store.dispatch(
      setSession({
        token: null,
        expiration: null,
      })
    );
    store.dispatch(clearUser());
    return "";
  }

  const token = await getIdToken(user, true);
  const tokenResult = await getIdTokenResult(user);

  store.dispatch(
    setSession({
      token: tokenResult.token,
      expiration: tokenResult.claims.exp,
    })
  );

  return token;
};

const apiClient = axios.create({
  baseURL: `${env.apiBaseUrl}/api`,
  headers: {
    "Content-Type": "application/json",
  },
});

apiClient.interceptors.request.use(
  async (config) => {
    showLoading();
    const apiKey = env.xApiKey;
    const token = await getAuthToken(config.token);

    if (apiKey) {
      config.headers["x-api-key"] = apiKey;
    }

    if (config.userStatus) {
      config.headers["user-status"] = config.userStatus;
    }

    if (token) {
      config.headers["Authorization"] = `${token}`;
    }

    return config;
  },
  (error) => {
    hideLoading();
    return Promise.reject(error);
  }
);

apiClient.interceptors.response.use(
  (response) => {
    const { data, status } = response;

    if (status === 200 || status === 201) {
      const { data: dataResponse } = data;
      hideLoading();
      return dataResponse;
    }

    hideLoading();
    return response;
  },
  (error) => {
    hideLoading();
    // Manejar el error de la respuesta
    if (error.response) {
      const { status, data } = error.response;
      console.error(
        `Error con status ${status}:`,
        data.message || "Error desconocido"
      );
    } else {
      console.error("Error sin respuesta del servidor:", error.message);
    }

    // Rechazar la promesa con el error para que puedas manejarlo en el código que hace la llamada
    return Promise.reject(error);
  }
);

export default apiClient;
